import { ProtestActStatus } from 'chaika-enums';
import sortBy from 'lodash/sortBy';
import { ProtestActData, ProtestActListQuery } from 'chaika-frontend-types/frontend-cms';
import { LongList } from '@store/abstract/LongList';

interface FilterParams extends ProtestActListQuery {}

export class ProtestList extends LongList<ProtestActData, ProtestActData, FilterParams> {
    protected create(params: ProtestActData): ProtestActData {
        return params;
    }

    protected getOrderedValues(params: ProtestActData[]): ProtestActData[] {
        const { fieldName } = this.orderParams as { fieldName: keyof ProtestActData };

        return sortBy(
            params.length > 1
                ? params.sort((a, b) => new Date(b[fieldName]).getTime() - new Date(a[fieldName]).getTime())
                : params,
            act =>
                act.status === ProtestActStatus.New
                    ? 0
                    : act.status === ProtestActStatus.InProcess
                      ? 1
                      : act.status === ProtestActStatus.Finish
                        ? 2
                        : 3,
        );
    }
}
